import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1c18444a from 'nuxt_plugin_plugin_1c18444a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_db72449c from 'nuxt_plugin_plugin_db72449c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_0d3023f0 from 'nuxt_plugin_cookieuniversalnuxt_0d3023f0' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_portalvue_27f5d9f3 from 'nuxt_plugin_portalvue_27f5d9f3' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_recaptcha_fa152662 from 'nuxt_plugin_recaptcha_fa152662' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_08970e60 from 'nuxt_plugin_axios_08970e60' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_7e452908 from 'nuxt_plugin_workbox_7e452908' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_7e7d12e2 from 'nuxt_plugin_metaplugin_7e7d12e2' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_752dc7fa from 'nuxt_plugin_iconplugin_752dc7fa' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_uuid_3cb5c7b4 from 'nuxt_plugin_uuid_3cb5c7b4' // Source: ../plugins/uuid.js (mode: 'all')
import nuxt_plugin_gsap_0d8e3474 from 'nuxt_plugin_gsap_0d8e3474' // Source: ../plugins/gsap.js (mode: 'all')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../plugins/swiper.js (mode: 'all')
import nuxt_plugin_viewportobserver_258e7530 from 'nuxt_plugin_viewportobserver_258e7530' // Source: ../plugins/viewport-observer.js (mode: 'all')
import nuxt_plugin_masonrylayout_01f1044f from 'nuxt_plugin_masonrylayout_01f1044f' // Source: ../plugins/masonry-layout.js (mode: 'client')
import nuxt_plugin_onnuxtready_2d6b0506 from 'nuxt_plugin_onnuxtready_2d6b0506' // Source: ../plugins/on-nuxt-ready.js (mode: 'client')
import nuxt_plugin_meta_374e7d44 from 'nuxt_plugin_meta_374e7d44' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"css":false,"mode":"out-in","beforeEnter":function(el) {
      this.$emit("before-enter", {
        el
      });
    },"enter":function(el, done) {
      this.$emit("enter", {
        el,
        done: done
      });
    },"afterEnter":function(el) {
      this.$emit("after-enter", {
        el
      });
    },"enterCancelled":function(el) {
      this.$emit("enter-cancelled", {
        el
      });
    },"beforeLeave":function(el) {
      this.$emit("before-leave", {
        el
      });
    },"leave":function(el, done) {
      this.$emit("leave", {
        el,
        done: done
      });
    },"afterLeave":function(el) {
      this.$emit("after-leave", {
        el
      });
    },"leaveCancelled":function(el) {
      this.$emit("leave-cancelled", {
        el
      });
    },"name":"page","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Fantini Rubinetti","htmlAttrs":{"lang":"en","dir":"ltr","translate":"no","class":"notranslate"},"script":[{"innerHTML":"window.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('consent', 'default', {\n  ad_storage: 'denied',\n  ad_user_data: 'denied',\n  ad_personalization: 'denied',\n  analytics_storage: 'denied',\n  functionality_storage: 'denied',\n  personalization_storage: 'denied',\n  security_storage: 'granted',\n  wait_for_update: 2000\n});"},{"innerHTML":"var _iub = _iub || [];\n(function() {\n  var ids = {\"it\":54574133,\"de\":99420984,\"en\":72876587,\"en_us\":31913010,\"es\":43361220,\"fr\":72486009,\"ru\":13881933};\n  var conf = {\"askConsentAtCookiePolicyUpdate\":true,\"countryDetection\":true,\"enableFadp\":true,\"enableLgpd\":true,\"enableTcf\":true,\"enableUspr\":true,\"floatingPreferencesButtonDisplay\":\"bottom-right\",\"googleAdditionalConsentMode\":true,\"lgpdAppliesGlobally\":false,\"perPurposeConsent\":true,\"whitelabel\":false,\"siteId\":2380823,\"banner\":{\"acceptButtonCaptionColor\":\"white\",\"acceptButtonColor\":\"#010101\",\"acceptButtonDisplay\":true,\"backgroundColor\":\"#f3f5f7\",\"backgroundOverlay\":true,\"brandBackgroundColor\":\"#ce0e2d\",\"brandTextColor\":\"#ffffff\",\"closeButtonRejects\":true,\"customizeButtonCaptionColor\":\"#4D4D4D\",\"customizeButtonColor\":\"#DADADA\",\"customizeButtonDisplay\":true,\"explicitWithdrawal\":true,\"fontSizeCloseButton\":\"14px\",\"listPurposes\":true,\"logo\":\"data:image\u002Fsvg+xml;base64,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\",\"ownerName\":\"www.fantini.it\u002F\",\"position\":\"float-bottom-center\",\"rejectButtonCaptionColor\":\"white\",\"rejectButtonColor\":\"#000000\",\"rejectButtonDisplay\":true,\"showPurposesToggles\":true,\"showTotalNumberOfProviders\":true,\"textColor\":\"#383b3d\"}};\n  var cookie = function (name) {\n    var found = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));\n    return found ? found[1] : '';\n  };\n  var locale = location.pathname.match(\u002F^\\\u002F([a-z]{2})-([a-z]{2})(?:\\\u002F|$)\u002F);\n  var lang = locale ? locale[1] : cookie('ft_lang');\n  var market = locale ? locale[2] : cookie('ft_market');\n  if (!ids[lang]) lang = 'en';\n  conf.lang = lang;\n  conf.cookiePolicyId = lang == 'en' && market == 'us' ? ids.en_us : ids[lang];\n  _iub.csConfiguration = conf;\n})();"},{"src":"https:\u002F\u002Fcs.iubenda.com\u002Fautoblocking\u002F2380823.js"},{"src":"\u002F\u002Fcdn.iubenda.com\u002Fcs\u002Ftcf\u002Fstub-v2.js"},{"src":"\u002F\u002Fcdn.iubenda.com\u002Fcs\u002Ftcf\u002Fsafe-tcf-v2.js"},{"src":"\u002F\u002Fcdn.iubenda.com\u002Fcs\u002Fccpa\u002Fstub.js"},{"src":"\u002F\u002Fcdn.iubenda.com\u002Fcs\u002Fiubenda_cs.js","charset":"UTF-8","async":true},{"src":"\u002F\u002Fjs-eu1.hsforms.net\u002Fforms\u002Fv2.js","defer":true},{"src":"\u002Fjs\u002Fjquery-3.6.0.slim.min.js","defer":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-FW6VJJ1R1L","defer":true},{"innerHTML":"window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n        gtag('config', 'G-FW6VJJ1R1L');"},{"innerHTML":"\n          !function(f,b,e,v,n,t,s)\n          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n          n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n          n.queue=[];t=b.createElement(e);t.async=!0;\n          t.src=v;s=b.getElementsByTagName(e)[0];\n          s.parentNode.insertBefore(t,s)}(window, document,'script',\n          'https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Ffbevents.js');\n          fbq('init', '865276573623883');\n          fbq('track', 'PageView');","class":"_iub_cs_activate","data-iub-purposes":"5"},{"innerHTML":"\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','GTM-TZXZ26CT');"},{"innerHTML":"\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','GTM-5G6WL7B');"}],"noscript":[{"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TZXZ26CT\"\n        height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","body":true}],"__dangerouslyDisableSanitizers":["script"],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5.0"},{"hid":"description","name":"description","content":""},{"hid":"google","name":"google","content":"notranslate"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1c18444a === 'function') {
    await nuxt_plugin_plugin_1c18444a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_db72449c === 'function') {
    await nuxt_plugin_plugin_db72449c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_0d3023f0 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_0d3023f0(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_27f5d9f3 === 'function') {
    await nuxt_plugin_portalvue_27f5d9f3(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_fa152662 === 'function') {
    await nuxt_plugin_recaptcha_fa152662(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_08970e60 === 'function') {
    await nuxt_plugin_axios_08970e60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_7e452908 === 'function') {
    await nuxt_plugin_workbox_7e452908(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_7e7d12e2 === 'function') {
    await nuxt_plugin_metaplugin_7e7d12e2(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_752dc7fa === 'function') {
    await nuxt_plugin_iconplugin_752dc7fa(app.context, inject)
  }

  if (typeof nuxt_plugin_uuid_3cb5c7b4 === 'function') {
    await nuxt_plugin_uuid_3cb5c7b4(app.context, inject)
  }

  if (typeof nuxt_plugin_gsap_0d8e3474 === 'function') {
    await nuxt_plugin_gsap_0d8e3474(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (typeof nuxt_plugin_viewportobserver_258e7530 === 'function') {
    await nuxt_plugin_viewportobserver_258e7530(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_masonrylayout_01f1044f === 'function') {
    await nuxt_plugin_masonrylayout_01f1044f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onnuxtready_2d6b0506 === 'function') {
    await nuxt_plugin_onnuxtready_2d6b0506(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_374e7d44 === 'function') {
    await nuxt_plugin_meta_374e7d44(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
